import VehiclesError from './VehiclesError.js'

export class NotFoundVehiclesError extends VehiclesError {
  static create(errorMessage) {
    return new NotFoundVehiclesError(errorMessage)
  }
}
